module.exports = __webpack_public_path__ + "img/icon-42.11ea3ba1.svg";